function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 214"
}, /*#__PURE__*/React.createElement("path", {
  className: "outline",
  "data-name": "Path 283",
  d: "M213.084 12.22l-1.915.129a9.619 9.619 0 00-8.956 8.956l-.129 1.919a.2.2 0 01-.4 0l-.129-1.919a9.618 9.618 0 00-8.956-8.956l-1.915-.129a.19.19 0 010-.38l1.915-.129a9.618 9.618 0 008.956-8.956l.129-1.915a.2.2 0 11.4 0l.129 1.915a9.619 9.619 0 008.96 8.956l1.915.129a.19.19 0 110 .38z",
  fill: "none",
  stroke: "#3c00dc"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 174",
  transform: "translate(-66.092 -43.527)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "outline",
  "data-name": "Ellipse 72",
  cx: 24.18,
  cy: 24.18,
  r: 24.18,
  transform: "translate(153.056 154.326)",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline",
  "data-name": "Path 276",
  d: "M177.238 276.366h46.49v-95.22c0-95.223-46.49-137.119-46.49-137.119s-46.489 41.896-46.489 137.119v95.22h46.493z",
  fill: "none",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline",
  "data-name": "Path 277",
  d: "M208.915 276.365v15.006h-63.12v-15.006",
  fill: "none",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.98
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 26",
  fill: "none",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.98,
  d: "M131.087 245.069h68.297"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline",
  "data-name": "Path 279",
  d: "M130.745 222.721s-50.1 28.263-64.163 92.838h12.742s27.139-30.507 51.421-39.194",
  fill: "none",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.98
}), /*#__PURE__*/React.createElement("path", {
  className: "outline",
  "data-name": "Path 280",
  d: "M223.728 222.721s50.107 28.263 64.163 92.838h-12.738s-27.139-30.507-51.425-39.194",
  fill: "none",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.98
}), /*#__PURE__*/React.createElement("path", {
  className: "outline",
  "data-name": "Line 27",
  fill: "none",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.98,
  d: "M218.403 127.938h-47.415"
})));

function SvgRocketOutlinedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222.289,
    height: 272.523,
    viewBox: "0 0 222.289 272.523"
  }, props), _ref);
}

export default SvgRocketOutlinedinline;